"use client";

import { useRef, useState } from 'react';
import styles from './_video.module.scss';
import Video from '@/components/video';
import Button from '@/components/button';


export default function HcpClinicalInformationVideo({
  transcript = null,
  video = null,
  heading = null,
  description = null,
  note = null,
  className = ''
}) {
  const videoRef = useRef(null);
  const [showTranscript, setShowTranscript] = useState(false);
  const [videoPlaying, setVideoPlaying] = useState(false);
  return (
    <section className={`${styles.container} ${className}`.trim()}>
      <div className="container">
        <div className={styles.content}>
          <Video
            customClass={`hcp-video ${styles.content_video}`}
            ref={videoRef}
            gtmEventCategory="Video"
            gtmEventAction="Start"
            gtmEventLabel="Initiating Crenessity Video Play/Pause Video"
            id="moa-video"
            autoplay={true}
            onVideoPause={() => setVideoPlaying(false)}
            onVideoPlay={() => setVideoPlaying(true)}
            caption={video.caption}
            {...video}
          />
          <p className={styles.content_heading}>{heading}</p>
          <p className={styles.content_description}>{description}</p>
          {note && <p className={styles.content_note}>{note}</p>}
          <div className={styles.transcript_toggle}>
            <Button
              onClick={() => setShowTranscript(!showTranscript)}
              data-gtm-event-category="Action"
              data-gtm-event-action="Click"
              data-gtm-event-label={showTranscript ? 'Close video transcript - Initiating Crenessity' : 'Read video transcript - Initiating Crenessity'}
            >
              {showTranscript ? 'Close video transcript' : 'Read video transcript'}
            </Button>
          </div>
          {showTranscript && <div className={`${styles.transcript} video-transcript`}>
            {transcript}
          </div>}
        </div>
      </div>
    </section>
  );
}
